import { Fetcher } from '../../Fetcher';

import type { PlayerConfigBodyType } from './types';

export interface FetchPlayerConfigSyncParams {
  JSESSIONID: string;
  ck: string;
  url: string;
  body: PlayerConfigBodyType;
}

export const fetchPlayerConfigSync = ({ JSESSIONID, ck, url, body }: FetchPlayerConfigSyncParams): Promise<unknown> => {
  return Fetcher.fetch<FetchPlayerConfigSyncParams, PlayerConfigBodyType>(url, {
    params: {
      JSESSIONID,
      ck,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body,
  });
};
